// extracted by mini-css-extract-plugin
export var loading = "THREE-module--loading--KXcN6";
export var loadingBar = "THREE-module--loadingBar--vaBSM";
export var loadingBarContainer = "THREE-module--loadingBarContainer--uzT37";
export var space = "THREE-module--space--IhEnT";
export var spaceText = "THREE-module--spaceText--EdJIo";